// extracted by mini-css-extract-plugin
export var downArrow = "_77-0";
export var label = "_77-1";
export var treatmentCard = "_77-3";
export var upArrow = "_77-2";